import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, useAuth } from "../context/AuthContext";
import { IndosbookMark } from "./IndosbookLogo";
import { Loader2 } from "lucide-react";

// Handles the Emergent Google OAuth callback:
// reads #session_id=... from the URL, exchanges it on the backend, then routes on.
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data.user);
        // clean the hash from the URL
        window.history.replaceState(null, "", window.location.pathname);
        if (res.data.needs_role) {
          navigate("/onboarding");
        } else {
          navigate("/feed");
        }
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white">
      <IndosbookMark size={48} />
      <div className="flex items-center gap-2 text-gray-500">
        <Loader2 className="h-5 w-5 animate-spin text-[#FF4500]" />
        Signing you in…
      </div>
    </div>
  );
};

export default AuthCallback;
